import styled from 'styled-components'
import { Button } from 'antd'
import { greys, borderRadius } from 'assets/themes/theme-default'

const ButtonGroup = Button.Group

export const AntButtonGroupStyled = styled(ButtonGroup)``

const AntButtonStyled = styled(Button)`
  &&& {
    border-radius: ${borderRadius.sm};
    padding: 0 25px;
    /*:disabled {
      background-color: ${greys.dark3};
      border-color: ${greys.dark3};
      color: ${greys.dark2};
    }*/
  }
  &&&.ant-btn-link{
    color:${props => props.theme.colors.color1.bg}
  }
  &&&.ant-btn-link:hover,
  &&&.ant-btn-link:focus,
  &&&.ant-btn-link:active {
    color: ${props => props.theme.colors.color1.bg};
    background: transparent;
  }
`

export default AntButtonStyled
